
export enum PaymentMethodEnum {
    Cash = 1,
    Pos = 2,
    TabletPos = 5,
  }
  